export const StandardURL = "https://backend.starrkun.co.ke";
// export const StandardURL = "http://localhost:8080";